import type { TechniqueData } from '../types';
import i18next from 'i18next';

const TECHNIQUE_CATEGORY_OVERRIDE_KEYS: Record<string, string> = {
  drift_fishing: 'boatBottomFishing',
  deep_dropping: 'boatBottomFishing',
  mediterranean_drifting: 'offshoreDrifting'
};

export const getNormalizedTechniqueCategory = (technique: Pick<TechniqueData, 'techniqueId' | 'category'>): string =>
  TECHNIQUE_CATEGORY_OVERRIDE_KEYS[technique.techniqueId]
    ? String(i18next.t(`codex:techniqueTaxonomy.categories.${TECHNIQUE_CATEGORY_OVERRIDE_KEYS[technique.techniqueId]}`))
    : technique.category;

export const withNormalizedTechniqueCategory = <T extends Pick<TechniqueData, 'techniqueId' | 'category'>>(technique: T): T & { category: string } => ({
  ...technique,
  category: getNormalizedTechniqueCategory(technique)
});
